import { http } from "./http.js";

async function createCabinetUser(user) {
  const response = await http.post("/isg-cabinet/users", user);
  return response;
}

export {
  createCabinetUser,
};